import { countryMatchesMarket } from './marketAnnouncementsUtils';

export const REGULATION_STATUS = {
  authorized: 'authorized',
  forbidden: 'forbidden',
  unavailable: 'unavailable',
};

export const REGULATION_GROUPS = [
  {
    id: 'bundles',
    label: 'Bundles with Device may contain',
    columns: [
      { id: 'bundlesHts', label: 'HTS' },
      { id: 'bundlesHns', label: 'HNS' },
      { id: 'bundlesAccessories', label: 'Accessories' },
    ],
  },
  {
    id: 'sticksOnline',
    label: 'Sticks online sales',
    columns: [
      { id: 'sticksHts', label: 'HTS' },
      { id: 'sticksHns', label: 'HNS' },
    ],
  },
  {
    id: 'promos',
    label: 'Promos allowed for',
    columns: [
      { id: 'promosDevices', label: 'Devices' },
      { id: 'promosSticks', label: 'Sticks' },
    ],
  },
];

export const REGULATION_COLUMNS = REGULATION_GROUPS.flatMap((group) => group.columns);

const A = REGULATION_STATUS.authorized;
const F = REGULATION_STATUS.forbidden;
const U = REGULATION_STATUS.unavailable;

export const MARKET_REGULATIONS = [
  {
    id: 'italy',
    code: 'IT',
    label: 'Italy',
    statuses: {
      bundlesHts: F,
      bundlesHns: F,
      bundlesAccessories: A,
      sticksHts: F,
      sticksHns: F,
      promosDevices: A,
      promosSticks: F,
    },
    comments: [
      {
        groupId: 'sticksOnline',
        text: 'Ploom: prices mentioned on the website, inviting to buy in-store. Competitor prices are not displayed; future updates should use third-party retailer sources.',
      },
    ],
  },
  {
    id: 'poland',
    code: 'PL',
    label: 'Poland',
    statuses: {
      bundlesHts: A,
      bundlesHns: A,
      bundlesAccessories: A,
      sticksHts: F,
      sticksHns: A,
      promosDevices: A,
      promosSticks: A,
    },
    comments: [
      {
        groupId: 'bundles',
        text: 'Online: Bundles can only be visible after registration. HTS can be part of bundles sold online as free of charge products only. HTS alone cannot be sold.',
      },
      {
        columnId: 'promosSticks',
        text: 'Promotions can be visible after registration. Promotions are usually targeted and redeemable with code in own retail or Żabka.',
      },
    ],
  },
  {
    id: 'romania',
    code: 'RO',
    label: 'Romania',
    statuses: {
      bundlesHts: A,
      bundlesHns: A,
      bundlesAccessories: A,
      sticksHts: A,
      sticksHns: A,
      promosDevices: A,
      promosSticks: A,
    },
    comments: [],
  },
  {
    id: 'uk',
    code: 'UK',
    label: 'United Kingdom',
    statuses: {
      bundlesHts: A,
      bundlesHns: U,
      bundlesAccessories: A,
      sticksHts: A,
      sticksHns: U,
      promosDevices: A,
      promosSticks: A,
    },
    comments: [],
  },
  {
    id: 'czech',
    code: 'CZ',
    label: 'Czech Republic',
    statuses: {
      bundlesHts: A,
      bundlesHns: A,
      bundlesAccessories: A,
      sticksHts: A,
      sticksHns: A,
      promosDevices: A,
      promosSticks: A,
    },
    comments: [
      {
        topic: 'Others',
        text: 'Glo transactions are handled through an external website.',
      },
    ],
  },
];

export function getCommentTopicLabel(comment) {
  if (comment?.topic) return comment.topic;
  if (comment?.columnId) {
    return REGULATION_COLUMNS.find((col) => col.id === comment.columnId)?.label || comment.columnId;
  }
  if (comment?.groupId) {
    return REGULATION_GROUPS.find((group) => group.id === comment.groupId)?.label || comment.groupId;
  }
  return 'Comment';
}

export function marketHasExpandableNotes(market) {
  return Array.isArray(market?.comments) && market.comments.length > 0;
}

export function findMarketRegulation(selectedMarket) {
  if (!selectedMarket) return null;
  return MARKET_REGULATIONS.find((market) => countryMatchesMarket(market.id, selectedMarket)) || null;
}

export function filterMarketRegulationsByCountries(selectedCountries) {
  if (!Array.isArray(selectedCountries) || selectedCountries.length === 0) {
    return MARKET_REGULATIONS;
  }
  return MARKET_REGULATIONS.filter((market) =>
    selectedCountries.some((country) => countryMatchesMarket(market.id, country))
  );
}
